export default "__VITE_PUBLIC_ASSET__4302a71e__"